function getRequestPath(config = {}) {
  const rawUrl = `${config.url || ''}`
  try {
    const baseURL =
      config.baseURL || window.location?.origin || 'http://localhost'
    return new URL(rawUrl, baseURL).pathname
  } catch (error) {
    return rawUrl.split('?')[0]
  }
}

function isUserAuthRequest(config) {
  const path = getRequestPath(config)
  return /(^|\/)v1\/user(\/|$)/.test(path)
}

export function shouldRetryRequestWithoutToken(config = {}) {
  if (config.__retriedWithoutAuth) {
    return false
  }

  return !isUserAuthRequest(config)
}

export function buildRequestWithoutToken(config = {}) {
  return {
    ...config,
    __retriedWithoutAuth: true,
    headers: {
      ...(config.headers || {}),
      Authorization: '',
    },
  }
}
